import React from 'react';
import { ProSheet, ProButton } from './proUi';

/**
 * The sheet after IS THIS YOUR BUSINESS? CLAIM IT (handoff §8). Two copies: a claim
 * link went to the contact on file (masked to one character), or no public contact
 * exists and an admin verifies by hand.
 */
export default function ClaimStartSheet({ businessName, result, onClose }) {
  const tokenMode = result?.mode === 'token' && result?.maskedContact;
  return (
    <ProSheet width={420} title="CLAIM THIS PAGE" onClose={onClose} testId="claim-start-sheet"
      footer={<ProButton fill size="md" onClick={onClose}>OK</ProButton>}>
      <p className="font-mono" style={{ padding: 18, fontSize: 13, lineHeight: 1.6 }}>
        {tokenMode ? (
          <>We&apos;ve sent a claim link to the address on {businessName}&apos;s website (<strong>{result.maskedContact}</strong>). Open it from that inbox to finish.</>
        ) : (
          <>We don&apos;t have a public contact for {businessName}. An admin will verify with you — expect a message within a day.</>
        )}
      </p>
    </ProSheet>
  );
}
